import { render, staticRenderFns } from "./approval-leave-index.vue?vue&type=template&id=3b56e93f&scoped=true"
import script from "./approval-leave-index.vue?vue&type=script&lang=js"
export * from "./approval-leave-index.vue?vue&type=script&lang=js"
import style0 from "./approval-leave-index.vue?vue&type=style&index=0&id=3b56e93f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b56e93f",
  null
  
)

export default component.exports